import { Typography } from 'antd';

import type { OptionRenderType } from '@app/components/MultipleSelect/MultipleSelect.types';

const { Paragraph } = Typography;

export const optionRender: OptionRenderType =
  ({ lastOptionRefCallback, optionDataTestId, length = 0 }) =>
  ({ data: { label } }, { index }) => {
    const isLast = index === length - 1;

    return (
      <div
        ref={isLast ? lastOptionRefCallback : undefined}
        style={{ width: '100%', minWidth: 0 }}
      >
        <Paragraph
          data-testid={optionDataTestId}
          className="multiple-select-options-label"
        >
          {label}
        </Paragraph>
      </div>
    );
  };
